fragment ExerciseByProductSliderFragment on exerciseByProductSlider_Entry {
  id
  typeHandle
  heading
  position
  productPages {
    ... on productPagesBlock_Entry {
      id
      image {
        url
        title
      }
      alt
      productPage {
        uri
      }
      label
    }
  }
}
